import { ApiClient } from '@api/api-configuration';
import { useQuery } from '@tanstack/react-query';

const params = {
  limit: 1000,
  offset: 0,
};

export const useDoctors = () => {
  const {
    data: res,
    isLoading,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: ['all-doctors-limit-100'],
    queryFn: async () => ApiClient.doctorsApi.doctors.listDoctors(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  const doctors = res?.data?.data || [];

  return {
    doctors,
    areDoctorsLoading: isLoading,
    areDoctorsFetching: isFetching,
    isError,
    error,
  };
};

export default useDoctors;
